import {FormEnvironment} from "@fd/Types.ts";
import {FormDefinition} from "@t/fd/layout/FormDefinition.ts";
import {SubviewTab} from "@t/ui/SubView.ts";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";

export type SourceTypeBundle = {
    icon?: string,
    create?: string,
    filter?: string,
    delete?: string,
    deleteConfirm?: string
};

export type SourceType = {
    id:number,
    subId?:number,
    fulltextCode?:string,
    form?:string,
    edit?:string,
    init?:string,
    create?:string,
    comments?:string,
    files?:string,
	/** Change log endpoint */
    changeLog?:string,
	editUrl?:string,
    meta?:boolean,
    bundle?: SourceTypeBundle,
    fileAsProperty?:string,
    idProperty?:string,	/* Defaults to "id" */
	subviews?: SubviewTab[]
};

// Known source types
export const SrcType = {
    TASK: 1,
    EVENT: 2,
    EMAIL: 3,
    OPPORTUNITY: 4,
    BUSCASE: 5,
    CONTACT: 6,
    PARTY: 7,
    PROBLEM: 9,
    USER: 10,
    INVOICE: 11,
    PRODUCT: 12,
    CONTENT: 13,
    OFFER: 14,
    TEMPLATE: 15,
    BRANCH: 16,
    STORE: 17,
    MOTION: 18,
    SMS: 19,
    GIFT: 20,
    BUSCASE_ITEM: 21,
    OFFER_ITEM: 22,
    TRANSFER: 23,
    ATTFILE: 24,
    REPEATED_EVENT: 25,
    CAMPAIGN: 26,
    TARGET_AUDIENCE: 27,
    ATTFILE_ATTACH: 28,
    KNOWLEDGE: 29,
    BULK_EMAIL: 30,
    RELATION: 31,
    CONSENT: 32,
    FACT: 33,
	POSTCODE: 34,
	BULK_SMS: 35,
	REGION: 36,
	DYNAMIC_ATTRIBUTE: 37,
	PREF: 38,
	FAVORITE_MAIL: 39,
	MAIL_ACCOUNT: 40,
	WORKSHEET_SETTING: 41,
	WORKSHEET: 42,
	SMS_ACCOUNT: 43,
	LOGINFO: 44,

	/** Special non-rowobject types */
	SUBVIEW: 500
} as const;

export type SrcType = typeof SrcType[keyof typeof SrcType];

/** Replace {id} placeholder in endpoint string (useful for SourceType.edit endpoint) */
export function setEndpointId(endpoint: string, id: number | string):string {
	return endpoint.replace("{id}", id.toString());
}


export async function loadSourceType(env: FormEnvironment, srcType: number): Promise<SourceType> {
	let allTypes = await env.sourceTypes();
	for (const type of allTypes) {
		if (type.id === srcType) return type;
	}
	throw new Error("Unknown source type " + srcType);
}

export async function loadFormDefinition(env: FormEnvironment, formName: string): Promise<InterfaceRoot<FormDefinition>> {
	let endpoint = "/api/forms/" + formName;
	let resp = await env.net.fetch(endpoint);
	if (resp.ok) return resp.json();
	throw new Error("Cannot load form " + formName);
}